export default {
    name: 'BookMark',
    dimensions: { width: 21, height: 41 },
    content: `
    <g fill="currentColor" stroke="none">
        <path d="M2.99268 0.998047C1.89268 0.998047 0.992676 1.89805 0.992676 2.99805V38.998C0.992676 40.678 2.93268 41.608 4.24268 40.558L10.9927 35.158L17.7427 40.558C19.0527 41.608 20.9927 40.668 20.9927 38.998V2.99805C20.9927 1.89805 20.0927 0.998047 18.9927 0.998047H2.99268ZM18.9927 38.998L12.2427 33.598L10.9927 32.598L9.74268 33.598L3.80268 38.348C3.47268 38.608 2.99268 38.378 2.99268 37.958V2.99805H17.9927C18.5427 2.99805 18.9927 3.44805 18.9927 3.99805V38.998Z" fill="#00112C"/>
    </g>
  `
};
